import { render, staticRenderFns } from "./LocationMenu.vue?vue&type=template&id=e6c4257e"
import script from "./LocationMenu.vue?vue&type=script&lang=js"
export * from "./LocationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports